"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ = require("./..");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Header = _styledComponents["default"].div.withConfig({
  displayName: "NormativityItem__Header",
  componentId: "rz5mdy-0"
})(["color:white;display:flex;align-items:center;justify-content:space-between;padding:0 40px 0 10px;background-color:#222a3e;"]);

var HeaderInfoContainer = _styledComponents["default"].div.withConfig({
  displayName: "NormativityItem__HeaderInfoContainer",
  componentId: "rz5mdy-1"
})(["flex:1;display:flex;align-items:center;"]);

var Select = (0, _styledComponents["default"])(_.Select).withConfig({
  displayName: "NormativityItem__Select",
  componentId: "rz5mdy-2"
})(["width:auto;"]);

var Body = _styledComponents["default"].div.withConfig({
  displayName: "NormativityItem__Body",
  componentId: "rz5mdy-3"
})(["color:white;padding-left:30px;display:grid;grid-template-columns:150px auto;grid-column-gap:10px;"]);

var TitleAditionalData = _styledComponents["default"].div.withConfig({
  displayName: "NormativityItem__TitleAditionalData",
  componentId: "rz5mdy-4"
})([""]);

var DescriptionAditionalData = _styledComponents["default"].div.withConfig({
  displayName: "NormativityItem__DescriptionAditionalData",
  componentId: "rz5mdy-5"
})([""]);

var DocumentList = _styledComponents["default"].div.withConfig({
  displayName: "NormativityItem__DocumentList",
  componentId: "rz5mdy-6"
})(["width:100%;"]);

var DocumentElement = _styledComponents["default"].div.withConfig({
  displayName: "NormativityItem__DocumentElement",
  componentId: "rz5mdy-7"
})(["width:100%;display:flex;align-items:center;"]);

var DocumentIcon = _styledComponents["default"].i.withConfig({
  displayName: "NormativityItem__DocumentIcon",
  componentId: "rz5mdy-8"
})(["background:url('", "') no-repeat;"], function (_ref) {
  var icon = _ref.icon;
  return icon;
});

var DocumentLink = _styledComponents["default"].a.withConfig({
  displayName: "NormativityItem__DocumentLink",
  componentId: "rz5mdy-9"
})([""]);

var NormativityItem = /*#__PURE__*/function (_Component) {
  _inherits(NormativityItem, _Component);

  var _super = _createSuper(NormativityItem);

  function NormativityItem() {
    var _this;

    _classCallCheck(this, NormativityItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleStatusChange", function (_ref2) {
      var statusId = _ref2.target.value;
      var _this$props = _this.props,
          onStatusChange = _this$props.onStatusChange,
          id = _this$props.id;
      onStatusChange(id, statusId);
    });

    _defineProperty(_assertThisInitialized(_this), "renderAditionalData", function (_ref3) {
      var name = _ref3.name,
          value = _ref3.value;
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
        key: name
      }, /*#__PURE__*/_react["default"].createElement(TitleAditionalData, null, name, ":"), /*#__PURE__*/_react["default"].createElement(DescriptionAditionalData, null, value));
    });

    _defineProperty(_assertThisInitialized(_this), "renderDocuments", function (_ref4) {
      var description = _ref4.description,
          url = _ref4.url,
          icon = _ref4.icon;
      return /*#__PURE__*/_react["default"].createElement(DocumentElement, {
        key: url
      }, /*#__PURE__*/_react["default"].createElement(DocumentIcon, {
        icon: icon
      }), /*#__PURE__*/_react["default"].createElement(DocumentLink, {
        href: url
      }, description));
    });

    return _this;
  }

  _createClass(NormativityItem, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          additionalData = _this$props2.additionalData,
          className = _this$props2.className,
          documentItems = _this$props2.documentItems,
          status = _this$props2.status,
          statusItems = _this$props2.statusItems,
          title = _this$props2.title;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "normativity-item ".concat(className)
      }, /*#__PURE__*/_react["default"].createElement(Header, null, /*#__PURE__*/_react["default"].createElement(HeaderInfoContainer, null, /*#__PURE__*/_react["default"].createElement("h4", null, title)), /*#__PURE__*/_react["default"].createElement(Select, {
        label: "Estatus de documento",
        name: "status",
        items: statusItems,
        value: status,
        onChange: this.handleStatusChange
      })), /*#__PURE__*/_react["default"].createElement(Body, null, documentItems && documentItems.length > 0 && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(TitleAditionalData, null, "Documento:"), /*#__PURE__*/_react["default"].createElement(DocumentList, null, documentItems.map(this.renderDocuments))), additionalData.map(this.renderAditionalData)));
    }
  }]);

  return NormativityItem;
}(_react.Component);

NormativityItem.propTypes = {
  additionalData: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    value: _propTypes["default"].string
  })),
  className: _propTypes["default"].string,
  documentItems: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    description: _propTypes["default"].string,
    url: _propTypes["default"].string,
    icon: _propTypes["default"].string
  })),
  iconName: _propTypes["default"].string,
  id: _propTypes["default"].number,
  onStatusChange: _propTypes["default"].func,
  status: _propTypes["default"].number,
  statusItems: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    description: _propTypes["default"].string,
    id: _propTypes["default"].string,
    className: _propTypes["default"].string
  })),
  title: _propTypes["default"].string
};
var _default = NormativityItem;
exports["default"] = _default;